module.exports = __webpack_public_path__ + "img/colon_sketch.3defa67e.png";